<template>
  <div>
    <Header :window="window" :parameters="'client'" />
    <div :class="window.width < 480 ? 'container-fluid' : 'container'">
      <div class="card div-card">
        <p style="font-size:36px">
          <img
            style="vertical-align:middle;width:36px"
            src="~@/assets/img/public_logo.png"
          />
          eventify
        </p>
        <div style="margin-top:10px;">
          <input
            class="input"
            type="text"
            name="URLPARTICIPANT"
            :placeholder="$t('public.code_participant')"
            v-model="shortcut"
          />
        </div>
        <div style="margin-top:10px;">
          <button
            class="button-client"
            v-bind="{ disabled: !this.shortcut }"
            @click="rejoindre()"
          >
            {{ $t("button.connecter") }}
          </button>
        </div>
      </div>
    </div>
    <Footer :window="window" />
    <!-- <div class="form_login">
      <img src="~@/assets/img/public_logo.png" class="public_home_logo" />
      <div>
        <input
          name="URLPARTICIPANT"
          class="input is-large"
          type="text"
          :placeholder="$t('public.code_participant')"
          v-model="shortcut"
        />
      </div>
    </div>
    <div @click="RejoindreMeeting">
      {{ $t("button.connecter") }}
    </div>
    <div class="clearfix"></div>
    <br /><br /><br /><br />
    <Footer /> -->
  </div>
</template>

<script>
import Footer from "@/components/layout/Footer";
import Header from "@/components/layout/Header";
export default {
  data() {
    return {
      shortcut: "",
      window: {
        width: window.innerWidth
      }
    };
  },
  components: {
    Footer,
    Header
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
    },
    rejoindre(evt) {
      if (!this.shortcut || this.shortcut.length !== 6) {
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$i18n.t("toast.reunion_invalide")
        });
      } else {
        window.location = this.shortcut + ".htm";
      }
    }
  }
};
</script>

<style scoped>
.div-card {
  margin-top: 5px;
  padding: 20px;
  text-align: center;
}
.input {
  background: #eeeeee !important;
  border-radius: 0px;
  max-width: 300px;
  box-shadow: none;
  font-size: 12px;
}
.input::placeholder {
  color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home.vue